const PROD_API_URL = "https://api.adblock.dev/v1/accounts";

const API_SUFFIX = "/v1/accounts";

const isLocalHost = () =>
    ["localhost", "10.0.0.", "0.0.0.0"].map((e) => window.location.host.startsWith(e)).filter((e) => e === true).length > 0;

const isDevURL = () =>
    ["dev-accounts"].map((e) => window.location.host.startsWith(e)).filter((e) => e === true).length > 0;

const getAPIURL = () => {
    let urlToReturn = PROD_API_URL;
    if (isLocalHost()) {
        urlToReturn = `http://${window.location.hostname}:8080${API_SUFFIX}`;
    } else if (isDevURL()) {
        urlToReturn = `https://dev-api.adblock.dev${API_SUFFIX}`;
    }
    return urlToReturn;
};

module.exports = {
    getAPIURL,
};
